import * as React from "react"

function WalmartSearchBoost(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 350" {...props}>
      <style>
        {
          ".walmart-search-boost_st3{fill:#fff}.walmart-search-boost_st4{fill:#e9ecef}.walmart-search-boost_st7{fill:#c1c6cb}.walmart-search-boost_st8{fill:none;stroke:#e9ecef;stroke-miterlimit:10}"
        }
      </style>
      <g id="walmart-search-boost_Guides_and_Back">
        <path
          d="M28.2 63.1c22.9-35.1 74-38 116-39.7C199.2 21 246.5 35 339 63.1c145.3 44.1 218.4 67.1 242.8 116 4.2 8.4 14.2 29.2 8.1 51.5-8 29-38.9 44.5-67.8 56-83.2 33.3-150.2 60.1-245 45-41.3-6.7-184.6-36.8-239.1-149.9-7.5-15.7-37-76.9-9.8-118.6z"
          fill="#1eca8a"
        />
        <path className="walmart-search-boost_st3" d="M50 50h500v250H50z" />
      </g>
      <g id="walmart-search-boost_Page_Content">
        <path className="walmart-search-boost_st4" d="M82.5 118.8h435v24.9h-435z" />
        <path
          className="walmart-search-boost_st4"
          d="M517 119.3v23.9H83v-23.9h434m1-1H82v25.9h436v-25.9zM82.5 257h435v24.9h-435z"
        />
        <path
          className="walmart-search-boost_st4"
          d="M517 257.5v23.9H83v-23.9h434m1-1H82v25.9h436v-25.9z"
        />
        <path fill="#00aeef" d="M82.5 144.4h435v24.9h-435z" />
        <path
          d="M517 144.9v23.9H83v-23.9h434m1-1H82v25.9h436v-25.9z"
          fill="#3fa9f5"
        />
        <path
          className="walmart-search-boost_st7"
          d="M106.3 75.9h27.6v8.6h-27.6zM325.4 75.9H353v8.6h-27.6zM390.7 75.9h39.9v8.6h-39.9zM462.7 75.9h39.9v8.6h-39.9zM165.9 75.9H222v8.6h-56.1zM106.3 101.4h33.8v8.6h-33.8zM325.4 101.4h32.9v8.6h-32.9zM401.6 101.4H418v8.6h-16.4zM401.6 126.9H418v8.6h-16.4z"
        />
        <path className="walmart-search-boost_st3" d="M401.6 152.6H418v8.6h-16.4z" />
        <path
          className="walmart-search-boost_st7"
          d="M401.6 265.1H418v8.6h-16.4zM165.9 101.4h132.4v8.6H165.9z"
        />
        <path
          className="walmart-search-boost_st3"
          d="M106.3 152.6h24v8.6h-24zM325.4 152.6h32.9v8.6h-32.9zM165.9 152.6h137.4v8.6H165.9z"
        />
        <path
          className="walmart-search-boost_st7"
          d="M106.3 126.9h33.8v8.6h-33.8zM135.6 181.6h33.8v8.6h-33.8zM135.6 202.8h140.5v8.6H135.6zM135.6 217.1h74.3v8.6h-74.3zM135.6 238.3h140.5v8.6H135.6zM291.2 202.8h206.5v8.6H291.2zM291.2 217.1H312v8.6h-20.8zM291.2 238.3h188.1v8.6H291.2zM291.2 181.6h67v8.6h-67zM325.4 126.9h32.9v8.6h-32.9zM165.9 126.9h125.3v8.6H165.9zM106.3 265.1h24v8.6h-24zM325.4 265.1h32.9v8.6h-32.9zM165.9 265.1h114.4v8.6H165.9z"
        />
        <path
          className="walmart-search-boost_st3"
          d="M97.7 156.4v1c0 .3-.2.5-.5.5H89c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h8.3c.2 0 .4.2.4.5z"
        />
        <path
          className="walmart-search-boost_st7"
          d="M97 130.2h-3v-3c0-.4-.3-.7-.7-.7h-.7c-.4 0-.7.3-.7.7v3h-3c-.4 0-.7.3-.7.7v.7c0 .4.3.7.7.7h3v3c0 .4.3.7.7.7h.7c.4 0 .7-.3.7-.7v-3h3c.4 0 .7-.3.7-.7v-.7c0-.4-.3-.7-.7-.7zM97 268.5h-3v-3c0-.4-.3-.7-.7-.7h-.7c-.4 0-.7.3-.7.7v3h-3c-.4 0-.7.3-.7.7v.7c0 .4.3.7.7.7h3v3c0 .4.3.7.7.7h.7c.4 0 .7-.3.7-.7v-3h3c.4 0 .7-.3.7-.7v-.7c0-.4-.3-.7-.7-.7zM97 104.7h-3v-3c0-.4-.3-.7-.7-.7h-.7c-.4 0-.7.3-.7.7v3h-3c-.4 0-.7.3-.7.7v.7c0 .4.3.7.7.7h3v3c0 .4.3.7.7.7h.7c.4 0 .7-.3.7-.7v-3h3c.4 0 .7-.3.7-.7v-.7c0-.4-.3-.7-.7-.7z"
        />
        <path className="walmart-search-boost_st8" d="M130.3 196.1h376.4M130.3 232h376.4" />
        <path
          d="M489.4 110.3h-13.6c-.9 0-1.5-.7-1.5-1.5v-7.5c0-.9.7-1.5 1.5-1.5h13.6c.8 0 1.5.7 1.5 1.5v7.5c.1.8-.6 1.5-1.5 1.5z"
          fill="#ed752b"
        />
        <g>
          <path
            d="M489.4 136.6h-13.6c-.9 0-1.5-.7-1.5-1.5v-7.5c0-.9.7-1.5 1.5-1.5h13.6c.8 0 1.5.7 1.5 1.5v7.5c.1.8-.6 1.5-1.5 1.5z"
            fill="#f0b922"
          />
        </g>
        <g>
          <path
            d="M489.4 162.2h-13.6c-.9 0-1.5-.7-1.5-1.5v-7.5c0-.9.7-1.5 1.5-1.5h13.6c.8 0 1.5.7 1.5 1.5v7.5c.1.8-.6 1.5-1.5 1.5z"
            fill="#c8d916"
          />
        </g>
        <g>
          <path
            d="M489.4 274.7h-13.6c-.9 0-1.5-.7-1.5-1.5v-7.5c0-.9.7-1.5 1.5-1.5h13.6c.8 0 1.5.7 1.5 1.5v7.5c.1.8-.6 1.5-1.5 1.5z"
            fill="#77c433"
          />
        </g>
      </g>
    </svg>
  )
}

export default WalmartSearchBoost
